(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["koppa-balm-content"] && !Shopify.designMode) return;
  try {
    (() => {
  const updatePage = () => document.body.classList.toggle('koppa-pdp-compact', !!document.querySelector('.cp-product--compact'));
  const reveal = (hash) => {
    if (!['#balm-formula', '#ingredients', '#balm-how', '#balm-shipping'].includes(hash)) return;
    const target = document.querySelector(hash === '#ingredients' ? '#balm-formula' : hash);
    if (!target) return;
    target.open = true;
    requestAnimationFrame(() => { target.scrollIntoView({ block: 'start', behavior: 'instant' }); target.querySelector('summary')?.focus({ preventScroll: true }); });
  };
  updatePage(); reveal(location.hash);
  document.addEventListener('shopify:section:load', updatePage);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(updatePage));
  window.addEventListener('hashchange', () => reveal(location.hash));
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.cp-product--compact a[href^="#"]');
    if (link) reveal(link.getAttribute('href'));
    const button = event.target.closest('[data-proof-index]');
    if (!button) return;
    const gallery = button.closest('[data-balm-proof]');
    const index = Number(button.dataset.proofIndex);
    gallery.querySelectorAll('[data-proof-panel]').forEach((panel, i) => { panel.hidden = i !== index; });
    gallery.querySelectorAll('[data-proof-index]').forEach((control, i) => control.setAttribute('aria-pressed', String(i === index)));
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["koppa-cart-recommendation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('koppa-cart-recommendation')) {
  customElements.define('koppa-cart-recommendation', class extends HTMLElement {
    connectedCallback() {
      try {
        const quiz = JSON.parse(sessionStorage.getItem('koppaQuizCart') || 'null');
        if (this.hasAttribute('data-quiz-only') && quiz && quiz.expires > Date.now()) {
          this.hidden = quiz.handle !== this.dataset.productHandle;
          this.style.display = this.hidden ? 'none' : '';
          if (this.hidden) return;
        } else if (this.hasAttribute('data-quiz-only')) { this.style.display = 'none'; return; }
      } catch (_) {}

      this.querySelector('button')?.addEventListener('click', async (event) => {
        const cart = this.closest('cart-items, cart-drawer-items');
        const drawer = this.closest('cart-drawer');
        if (!cart || cart.updating) return;
        cart.updating = true;
        cart.setAttribute('aria-busy', 'true');
        cart.querySelector('#main-cart-items')?.classList.add('cart__items--disabled');
        const wallets = cart.querySelector('.additional-checkout-buttons');
        if (wallets) wallets.inert = true;
        const checkout = (drawer || cart).querySelector('[name="checkout"]');
        if (checkout) checkout.disabled = true;
        const button = event.currentTarget;
        const error = this.querySelector('[role="alert"]');
        const label = button.textContent;
        button.disabled = true;
        button.textContent = window.koppaCartStrings.adding;
        error.hidden = true;
        let added = false;
        try {
          const response = await fetch(window.routes.cart_add_url, {
            method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({items: [{id: Number(button.dataset.variantId), quantity: 1}]})
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || window.koppaCartStrings.error);
          added = true;
          if (drawer) await drawer.refresh();
          else await cart.onCartUpdate();
          const heading = (drawer || cart).querySelector('.drawer__heading, .cc-hl');
          heading?.setAttribute('tabindex', '-1');
          heading?.focus();
        } catch (err) {
          if (added) { window.location.assign(window.routes.cart_url); return; }
          error.textContent = err.message || window.koppaCartStrings.error;
          error.hidden = false;
          button.textContent = label;
          button.disabled = false;
        } finally {
          cart.updating = false;
          cart.removeAttribute('aria-busy');
          cart.querySelector('#main-cart-items')?.classList.remove('cart__items--disabled');
          if (wallets?.isConnected) wallets.inert = false;
          if (checkout?.isConnected) checkout.disabled = false;
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["koppa-cart-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('koppa-cart-reviews')) {
  customElements.define('koppa-cart-reviews', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); clearInterval(this.interval);
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovered = false;
      this.dataset.enhanced = 'true';
      this.play = this.querySelector('[data-play]');
      this.update();
      if (this.slides.length < 2) return;
      this.querySelector('.kc-reviews__controls').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-play')) { this.paused = !this.paused; this.update(); }
        else if (button.dataset.direction) this.advance(Number(button.dataset.direction), true);
      }, {signal});
      this.addEventListener('pointerenter', () => { this.hovered = true; }, {signal});
      this.addEventListener('pointerleave', () => { this.hovered = false; }, {signal});
      this.addEventListener('focusin', event => {
        if (!this.contains(event.relatedTarget) && event.target !== this.play) { this.paused = true; this.update(); }
      }, {signal});
      this.motion.addEventListener('change', event => { if (event.matches) { this.paused = true; this.update(); } }, {signal});
      this.addEventListener('touchstart', event => { this.touch = {x:event.touches[0].clientX,y:event.touches[0].clientY}; }, {passive:true,signal});
      this.addEventListener('touchend', event => {
        if (!this.touch || !event.changedTouches.length) return;
        const x = event.changedTouches[0].clientX - this.touch.x;
        const y = event.changedTouches[0].clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(x) < 45 || Math.abs(x) < Math.abs(y)) return;
        const rtl = getComputedStyle(this).direction === 'rtl';
        this.advance((x < 0 ? 1 : -1) * (rtl ? -1 : 1), true);
      }, {passive:true,signal});
      this.interval = setInterval(() => {
        if (!this.paused && !this.hovered && !document.hidden) this.advance(1);
      }, 18000);
    }
    disconnectedCallback() { clearInterval(this.interval); this.abort?.abort(); }
    advance(direction, manual = false) {
      this.index = (this.index + direction + this.slides.length) % this.slides.length;
      if (manual) this.paused = true;
      this.update();
      if (manual) this.querySelector('[data-status]').textContent = this.dataset.position.replace('[current]', this.index + 1).replace('[total]', this.slides.length);
    }
    update() {
      this.slides.forEach((slide, index) => {
        slide.classList.toggle('is-current', index === this.index);
        slide.setAttribute('aria-hidden', String(index !== this.index));
        slide.inert = index !== this.index;
      });
      const count = this.querySelector('[data-count]');
      if (count) count.textContent = `${this.index + 1} / ${this.slides.length}`;
      if (this.play) this.play.textContent = this.paused ? this.play.dataset.playLabel : this.play.dataset.pauseLabel;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["koppa-cart-session"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('koppa-cart-session')) {
  customElements.define('koppa-cart-session', class extends HTMLElement {
    connectedCallback() {
      this.key = 'koppa-bag-reminder-v1';
      if (this.dataset.empty === 'true') {
        try { localStorage.removeItem(this.key); } catch (_) {}
        delete window.koppaBagReminder;
        return;
      }
      let expiry;
      try { expiry = Number(localStorage.getItem(this.key)); } catch (_) {}
      this.expiry = expiry > 0 && Number.isFinite(expiry) ? expiry : window.koppaBagReminder || Date.now() + 15 * 60 * 1000;
      window.koppaBagReminder = this.expiry;
      try { localStorage.setItem(this.key, String(this.expiry)); } catch (_) {}
      this.hidden = false;
      this.note = this.querySelector('[data-message]').textContent;
      this.interval = setInterval(() => this.tick(), 1000);
      this.tick();
      this.sync = event => { if (event.key === this.key && event.newValue) { const next = Number(event.newValue); if (Number.isFinite(next) && next > 0) { this.expiry = next; clearInterval(this.interval); this.interval = setInterval(() => this.tick(), 1000); this.tick(); } } };
      window.addEventListener('storage', this.sync);
    }
    disconnectedCallback() { clearInterval(this.interval); window.removeEventListener('storage', this.sync); }
    tick() {
      const remaining = Math.max(0, Math.ceil((this.expiry - Date.now()) / 1000));
      this.querySelector('[data-time]').textContent = `${String(Math.floor(remaining / 60)).padStart(2, '0')}:${String(remaining % 60).padStart(2, '0')}`;
      this.querySelector('.kc-session__clock').hidden = remaining === 0;
      this.querySelector('[data-message]').textContent = remaining ? this.note : this.dataset.finished;
      if (!remaining) {
        this.querySelector('.kc-session__clock').hidden = true;
        this.querySelector('[data-message]').textContent = this.dataset.finished;
        clearInterval(this.interval);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["koppa-cart-shipping-estimator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('koppa-shipping-estimator')) {
  customElements.define('koppa-shipping-estimator', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.country = this.querySelector('[name="country"]');
      this.province = this.querySelector('[name="province"]');
      this.result = this.querySelector('[role="status"]');
      this.country.value = this.dataset.country;
      this.updateProvinces();
      this.country.addEventListener('change', () => this.updateProvinces());
      this.form.addEventListener('change', () => {
        this.request?.abort();
        this.request = null;
        this.result.replaceChildren();
      });
      this.form.addEventListener('submit', (event) => this.estimate(event));
    }
    disconnectedCallback() { this.request?.abort(); }
    updateProvinces() {
      const values = JSON.parse(this.country.selectedOptions[0]?.dataset.provinces || '[]');
      this.province.replaceChildren(...values.map(([value, label]) => new Option(label, value)));
      this.querySelector('.kc-province').hidden = values.length === 0;
      this.province.disabled = values.length === 0;
    }
    async estimate(event) {
      event.preventDefault();
      this.request?.abort();
      const controller = new AbortController();
      this.request = controller;
      const button = this.querySelector('button');
      const label = button.textContent;
      button.disabled = true;
      this.result.textContent = this.dataset.loading;
      this.result.setAttribute('aria-busy', 'true');
      const params = new URLSearchParams();
      for (const [key, value] of new FormData(this.form)) params.set(`shipping_address[${key}]`, value.trim());
      const root = window.Shopify.routes.root;
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const prepare = await fetch(`${root}cart/prepare_shipping_rates.json?${params}`, {method: 'POST', signal: controller.signal});
        if (!prepare.ok) throw new Error();
        let rates;
        for (let attempt = 0; attempt < 12; attempt++) {
          if (controller.signal.aborted) throw new Error();
          const response = await fetch(`${root}cart/async_shipping_rates.json?${params}`, {signal: controller.signal});
          if (!response.ok) throw new Error();
          const payload = await response.json();
          if (payload !== null) { rates = payload.shipping_rates; break; }
          await new Promise(resolve => setTimeout(resolve, 600));
        }
        if (!Array.isArray(rates)) throw new Error();
        this.result.replaceChildren();
        if (!rates.length) { this.result.textContent = this.dataset.empty; return; }
        const list = document.createElement('ul');
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: this.dataset.currency});
        const dateFormat = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {month:'short', day:'numeric', timeZone:'UTC'});
        for (const rate of rates) {
          const row = document.createElement('li');
          const name = document.createElement('span');
          const price = document.createElement('strong');
          name.textContent = rate.presentment_name || rate.name;
          price.textContent = Number(rate.price) === 0 ? this.dataset.free : money.format(Number(rate.price));
          row.append(name, price);
          const dates = rate.delivery_range || (rate.delivery_date ? [rate.delivery_date] : []);
          const validDates = dates.map(date => new Date(date)).filter(date => !Number.isNaN(date.valueOf()));
          if (validDates.length) {
            const delivery = document.createElement('small');
            delivery.textContent = `${this.dataset.delivery} ${validDates.map(date => dateFormat.format(date)).join(' – ')}`;
            row.append(delivery);
          }
          list.append(row);
        }
        this.result.append(list);
      } catch (_) {
        if (this.isConnected && this.request === controller) this.result.textContent = this.dataset.error;
      } finally {
        clearTimeout(timeout);
        button.disabled = false;
        button.textContent = label;
        this.result.removeAttribute('aria-busy');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["koppa-catalog"] && !Shopify.designMode) return;
  try {
    (() => {
    function initialize(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const cards = Array.from(root.querySelectorAll('.ks-card'));
      root.querySelectorAll('[data-waitlist-name]').forEach(link => link.addEventListener('click', event => {
        if (!window.koppaOpenWaitlist) return;
        event.preventDefault();
        window.koppaOpenWaitlist({ name: link.dataset.waitlistName, handle: link.dataset.waitlistHandle });
      }));
      root.querySelectorAll('.ks-product-form').forEach(form => form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = form.querySelector('button');
        const status = form.querySelector('.ks-form-status');
        if (button.disabled) return;
        button.disabled = true; button.textContent = button.dataset.addingLabel; status.textContent = '';
        try {
          const body = new FormData(form);
          const drawer = document.querySelector('cart-drawer');
          if (drawer?.getSectionsToRender) {
            body.append('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
            body.append('sections_url', location.pathname);
            drawer.setActiveElement(button);
          }
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || status.dataset.error);
          button.textContent = button.dataset.addedLabel;
          status.textContent = button.dataset.addedLabel;
          if (drawer?.renderContents && result.sections && Object.values(result.sections).every(Boolean)) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(result);
          } else { window.location.assign((window.Shopify?.routes?.root || '/') + 'cart'); }
          document.dispatchEvent(new CustomEvent('koppa:cart-added', { detail: { product: result } }));
        } catch (error) { status.textContent = error.message || status.dataset.error; }
        finally { button.disabled = false; button.textContent = button.dataset.addLabel; }
      }));
    }
    document.querySelectorAll('[data-catalog]').forEach(initialize);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-catalog]').forEach(initialize));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["koppa-men-editable-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('koppa-men-reviews')) {
    customElements.define('koppa-men-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.track = this.querySelector('[data-men-review-track]');
        this.items = [...this.querySelectorAll('[data-men-review]')];
        if (!this.track || !this.items.length) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.prev = this.querySelector('[data-men-review-prev]');
        this.next = this.querySelector('[data-men-review-next]');
        this.dots = [...this.querySelectorAll('[data-men-review-dot]')];
        this.querySelector('[data-men-review-controls]').hidden = false;
        this.querySelector('[data-men-review-dots]').hidden = false;
        this.prev.addEventListener('click', () => this.go(this.current - 1), options);
        this.next.addEventListener('click', () => this.go(this.current + 1), options);
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i), options));
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          let index;
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.items.length - 1;
          else if (event.key === 'ArrowRight') index = this.current + (rtl ? -1 : 1);
          else if (event.key === 'ArrowLeft') index = this.current + (rtl ? 1 : -1);
          else return;
          event.preventDefault();
          this.go(index);
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.items.findIndex(item => item.dataset.menReview === event.detail?.blockId);
          if (index >= 0) this.go(index, 'auto');
        }, options);
        this.videos = [...this.querySelectorAll('video')];
        this.videos.forEach(video => video.addEventListener('play', () => {
          this.videos.forEach(other => { if (other !== video) other.pause(); });
        }, options));
        this.visibility = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) entry.target.pause();
        }));
        this.videos.forEach(video => this.visibility.observe(video));
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.videos.forEach(video => video.pause());
        }, options);
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
      }
      update() {
        const edge = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        let closest = 0, distance = Infinity;
        this.items.forEach((item, i) => {
          const rect = item.getBoundingClientRect();
          const d = Math.abs(rtl ? edge.right - rect.right : rect.left - edge.left);
          if (d < distance) { closest = i; distance = d; }
        });
        this.current = closest;
        const offset = Math.abs(this.track.scrollLeft);
        this.prev.disabled = offset < 2;
        this.next.disabled = offset >= this.track.scrollWidth - this.track.clientWidth - 2;
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === closest)));
      }
      go(index, behavior) {
        const item = this.items[Math.max(0, Math.min(this.items.length - 1, index))];
        const rect = item.getBoundingClientRect(), edge = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollBy({ left: rtl ? rect.right - edge.right : rect.left - edge.left, behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth') });
      }
      disconnectedCallback() {
        this.abort?.abort(); this.abort = null;
        this.resize?.disconnect(); this.visibility?.disconnect();
        this.videos?.forEach(video => video.pause());
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["koppa-product-quick-details"] && !Shopify.designMode) return;
  try {
    (() => {
  const revealIngredients = () => {
    if (window.location.hash !== '#ingredients') return;
    const disclosure = document.querySelector('details[data-koppa-ingredients]');
    if (!disclosure) return;
    disclosure.open = true;
    requestAnimationFrame(() => {
      disclosure.scrollIntoView({ block: 'start', behavior: 'instant' });
      disclosure.querySelector('summary')?.focus({ preventScroll: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealIngredients, { once: true });
  else revealIngredients();
  window.addEventListener('hashchange', revealIngredients);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["koppa-serum-ritual"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('koppa-serum-ritual')) {
    customElements.define('koppa-serum-ritual', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const options = {signal:this.events.signal};
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.current = 0;
        this.querySelector('[data-controls]').hidden = false;
        this.querySelector('[data-previous]').addEventListener('click',()=>this.show(this.current-1),options);
        this.querySelector('[data-next]').addEventListener('click',()=>this.show(this.current+1),options);
        this.addEventListener('keydown',event=>{
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.show(this.current+(event.key==='ArrowRight'?1:-1));
        },options);
        this.addEventListener('touchstart',event=>{
          if(event.touches.length===1) this.touch={x:event.touches[0].clientX,y:event.touches[0].clientY};
        },{...options,passive:true});
        this.addEventListener('touchend',event=>{
          if(!this.touch || !event.changedTouches.length) return;
          const dx=event.changedTouches[0].clientX-this.touch.x;
          const dy=event.changedTouches[0].clientY-this.touch.y;
          this.touch=null;
          if(Math.abs(dx)>48 && Math.abs(dx)>Math.abs(dy)*1.5) this.show(this.current+(dx<0?1:-1));
        },{...options,passive:true});
        this.show(0,false);
      }
      disconnectedCallback() { this.events?.abort(); this.events=null; }
      show(index,announce=true) {
        this.current=(index+this.slides.length)%this.slides.length;
        this.slides.forEach((slide,i)=>{slide.hidden=i!==this.current;});
        this.querySelectorAll('[data-marker]').forEach((marker,i)=>marker.classList.toggle('is-active',i===this.current));
        this.querySelector('[data-count]').textContent=String(this.current+1).padStart(2,'0')+' / '+String(this.slides.length).padStart(2,'0');
        if(announce) this.querySelector('[data-status]').textContent=this.slides[this.current].dataset.announcement;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["koppa-subscription-value"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.KoppaSubscriptionValue) return;
  window.KoppaSubscriptionValue = true;
  document.addEventListener('click', event => {
    const choice = event.target.closest('[data-subscription-choice]');
    if (!choice || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const section = choice.closest('[data-subscription-value]');
    const page = section.closest('.pp');
    const forms = [...page.querySelectorAll('#product-purchase form[data-type="add-to-cart-form"]')];
    const visible = forms.find(form => form.getBoundingClientRect().width > 0);
    if (!visible) return;
    const plan = choice.dataset.subscriptionChoice;
    const controls = [...visible.querySelectorAll('[name="selling_plan"]')];
    const target = controls.find(control => control.matches('select') ? [...control.options].some(option => option.value === plan) : control.value === plan);
    event.preventDefault();
    if (plan && !target) {
      const status = section.querySelector('.ksv-status');
      status.textContent = section.dataset.selectionError;
      status.hidden = false;
      return;
    }
    forms.forEach(form => {
      const select = form.querySelector('select[name="selling_plan"]');
      if (select && [...select.options].some(option => option.value === plan)) {
        select.value = plan;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      form.querySelectorAll('input[type="radio"][name="selling_plan"]').forEach(input => {
        input.checked = input.value === plan;
        if (input.checked) input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    const focus = target || visible.querySelector('button[type="submit"]');
    focus?.focus({ preventScroll: true });
    const panel = visible.closest('.koppa-mobile-order') || visible;
    panel.scrollIntoView({ block:'center', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["koppa-thanks-footer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-thanks-privacy]').forEach((button) => {
    button.hidden = false;
    button.addEventListener('click', async () => {
      const status = button.closest('footer').querySelector('[data-thanks-privacy-status]');
      try {
        if (window.KoppaConsent) await window.KoppaConsent.openPreferences();
        else if (window.privacyBanner && window.privacyBanner.showPreferences) await window.privacyBanner.showPreferences();
        else throw new Error('Unavailable');
        status.textContent = '';
      } catch (_) { status.textContent = status.dataset.error; }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["koppa-ugc-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('koppa-ugc')) {
    customElements.define('koppa-ugc', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.koppa-ugc__track');
        if (!this.track || this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.items = Array.from(this.querySelectorAll('[data-ugc-item]'));
        this.videos = Array.from(this.querySelectorAll('video'));
        this.prev = this.querySelector('[data-ugc-prev]');
        this.next = this.querySelector('[data-ugc-next]');
        this.status = this.querySelector('[data-ugc-status]');
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        this.querySelector('.koppa-ugc__controls')?.removeAttribute('hidden');
        this.prev?.addEventListener('click', () => this.move(-1), options);
        this.next?.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') this.go(0);
          else if (event.key === 'End') this.go(this.items.length - 1);
          else this.move((event.key === 'ArrowRight' ? 1 : -1) * (this.rtl ? -1 : 1));
        }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.visibility = new IntersectionObserver(entries => {
          entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); });
        }, { threshold: .25 });
        this.videos.forEach(video => {
          const play = video.parentElement.querySelector('[data-ugc-play]');
          video.controls = false;
          play.hidden = false;
          play.addEventListener('click', async () => {
            video.controls = true;
            play.hidden = true;
            try { await video.play(); } catch { video.controls = true; play.hidden = false; }
          }, options);
          video.addEventListener('play', () => {
            video.controls = true;
            play.hidden = true;
            document.querySelectorAll('koppa-ugc video').forEach(other => { if (other !== video) other.pause(); });
          }, options);
          video.addEventListener('ended', () => { play.hidden = false; video.controls = false; }, options);
          this.visibility.observe(video);
        });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.videos.forEach(video => video.pause());
        }, options);
        this.update();
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const offset = Math.abs(this.track.scrollLeft);
        const edge = this.track.getBoundingClientRect();
        let closest = 0, distance = Infinity;
        this.items.forEach((item, index) => {
          const rect = item.getBoundingClientRect();
          const d = Math.abs(this.rtl ? edge.right - rect.right : rect.left - edge.left);
          if (d < distance) { distance = d; closest = index; }
        });
        this.current = closest;
        if (this.prev) this.prev.disabled = offset <= 2;
        if (this.next) this.next.disabled = offset >= max - 2;
        this.querySelector('[data-ugc-current]').textContent = String(closest + 1).padStart(2, '0');
        this.status.textContent = this.status.dataset.template.replace('[current]', closest + 1);
      }
      move(direction) { this.go(Math.max(0, Math.min(this.items.length - 1, this.current + direction))); }
      go(index) {
        const item = this.items[index].getBoundingClientRect();
        const track = this.track.getBoundingClientRect();
        const delta = this.rtl ? item.right - track.right : item.left - track.left;
        this.track.scrollBy({ left: delta, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
        this.resize?.disconnect();
        this.visibility?.disconnect();
        cancelAnimationFrame(this.frame);
        this.videos?.forEach(video => video.pause());
      }
    });
  }

  if (!window.koppaReviewFullSizePhotos) {
    window.koppaReviewFullSizePhotos = true;
    const originalPhotoUrl = (image) => {
      const raw = image.currentSrc || image.src;
      const url = new URL(raw, window.location.href);
      url.searchParams.delete('width');
      return url.href;
    };
    const prepareReviewPhotos = (root = document) => {
      root.querySelectorAll('.koppa-ugc__item img').forEach((image) => {
        if (image.closest('figcaption')) return;
        image.setAttribute('role', 'button');
        image.setAttribute('tabindex', '0');
        image.setAttribute('aria-label', image.alt ? 'View full-size photo: ' + image.alt : 'View full-size customer photo');
      });
    };
    document.addEventListener('click', (event) => {
      const image = event.target.closest('.koppa-ugc__item img');
      if (!image || image.closest('figcaption')) return;
      window.open(originalPhotoUrl(image), '_blank', 'noopener');
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const image = event.target.closest('.koppa-ugc__item img');
      if (!image || image.closest('figcaption')) return;
      event.preventDefault();
      window.open(originalPhotoUrl(image), '_blank', 'noopener');
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepareReviewPhotos());
    else prepareReviewPhotos();
  }

  if (!window.koppaVersionAGallery) {
    window.koppaVersionAGallery = true;
    const setImportant = (element, property, value) => element?.style.setProperty(property, value, 'important');
    const applyVersionA = (root) => {
      const compactProduct = window.innerWidth >= 768 && !!root.closest('[data-product-key=serum], [data-product-key=cream], [data-product-key=balm]');
      const width = window.innerWidth;
      const mobile = width < 700;
      const columns = width >= 1360 ? 4 : width >= 1024 ? 3 : width >= 700 ? 2 : 1;
      const gap = mobile ? 12 : 16;
      const basis = mobile ? '89%' : 'calc((100% - ' + (gap * (columns - 1)) + 'px) / ' + columns + ')';
      const track = root.querySelector('.koppa-ugc__track');
      const inner = root.querySelector('.koppa-ugc__inner');
      const header = root.querySelector('.koppa-ugc__header');
      const controls = root.querySelector('.koppa-ugc__controls');
      const footer = root.querySelector('.koppa-ugc__footer');
      const firstMedia = root.querySelector('.koppa-ugc__item .koppa-ugc__media');
      setImportant(root, 'display', 'block');
      setImportant(root, 'background', compactProduct ? 'transparent' : '#fff');
      setImportant(root, 'color', '#0b1b38');
      setImportant(inner, 'background', compactProduct ? 'transparent' : '#fff');
      setImportant(header, 'position', 'relative');
      setImportant(header, 'display', 'flex');
      setImportant(header, 'justify-content', 'space-between');
      setImportant(header, 'align-items', 'flex-end');
      setImportant(controls, 'display', mobile ? 'none' : 'flex');
      if (!mobile && controls && firstMedia) {
        const headerRect = header.getBoundingClientRect();
        const trackRect = track.getBoundingClientRect();
        const mediaRect = firstMedia.getBoundingClientRect();
        setImportant(controls, 'position', 'absolute');
        setImportant(controls, 'z-index', '3');
        setImportant(controls, 'left', Math.round(trackRect.left - headerRect.left - 40) + 'px');
        setImportant(controls, 'right', Math.round(headerRect.right - trackRect.right - 40) + 'px');
        setImportant(controls, 'top', Math.round(mediaRect.top - headerRect.top + mediaRect.height / 2) + 'px');
        setImportant(controls, 'justify-content', 'space-between');
        setImportant(controls, 'transform', 'translateY(-50%)');
        setImportant(controls, 'pointer-events', 'none');
        controls.querySelectorAll('button').forEach((button) => setImportant(button, 'pointer-events', 'auto'));
      }
      setImportant(track, 'display', 'flex');
      setImportant(track, 'flex-direction', 'row');
      setImportant(track, 'align-items', 'stretch');
      setImportant(track, 'grid-template-columns', 'none');
      setImportant(track, 'gap', gap + 'px');
      setImportant(track, 'overflow-x', 'auto');
      setImportant(track, 'overflow-y', 'hidden');
      setImportant(track, 'scroll-snap-type', 'x mandatory');
      setImportant(track, 'scroll-behavior', matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
      setImportant(track, 'margin-inline-end', mobile ? '-20px' : '0');
      setImportant(track, 'padding-inline-end', mobile ? '20px' : '1px');
      root.querySelectorAll('.km-community-column').forEach((column) => {
        const columnItems = Array.from(column.querySelectorAll(':scope > .koppa-ugc__item'));
        if (columnItems.length) column.replaceWith(...columnItems);
      });
      root.querySelectorAll('.kd-community-more').forEach((wrapper) => {
        const hiddenItems = Array.from(wrapper.querySelectorAll('.koppa-ugc__item'));
        if (hiddenItems.length) wrapper.replaceWith(...hiddenItems);
      });
      root.querySelectorAll('.kd-community-more, .kd-community-more > div').forEach((element) => setImportant(element, 'display', 'contents'));
      root.querySelectorAll('.kd-community-more > summary').forEach((element) => setImportant(element, 'display', 'none'));
      root.querySelectorAll('.koppa-ugc__item').forEach((item) => {
        setImportant(item, 'display', 'flex');
        setImportant(item, 'height', 'auto');
        setImportant(item, 'min-height', '0');
        setImportant(item, 'flex-direction', 'column');
        setImportant(item, 'align-self', 'stretch');
        setImportant(item, 'flex', '0 0 ' + basis);
        setImportant(item, 'width', 'auto');
        setImportant(item, 'min-width', '0');
        setImportant(item, 'scroll-snap-align', 'start');
        setImportant(item, 'background', '#fff');
        setImportant(item, 'border', '1px solid #dce1e7');
        setImportant(item, 'overflow', 'hidden');
        const media = item.querySelector('.koppa-ugc__media');
        setImportant(media, 'display', media?.classList.contains('koppa-ugc__comparison') ? 'grid' : 'block');
        setImportant(media, 'grid-template-columns', 'repeat(2, minmax(0, 1fr))');
        setImportant(media, 'grid-template-rows', 'minmax(0, 1fr)');
        setImportant(media, 'gap', '0');
        media?.querySelectorAll('.koppa-ugc__comparison-photo').forEach((frame) => {
          if (compactProduct) {
            setImportant(frame, 'display', 'block');
            setImportant(frame, 'grid-column', 'auto');
            setImportant(frame, 'grid-row', '1');
          }
          setImportant(frame, 'position', 'relative');
          setImportant(frame, 'height', '100%');
          setImportant(frame, 'min-height', '0');
          setImportant(frame, 'overflow', 'hidden');
        });
        setImportant(media, 'width', '100%');
        setImportant(media, 'height', 'auto');
        setImportant(media, 'min-height', '0');
        setImportant(media, 'max-height', 'none');
        setImportant(media, 'position', 'relative');
        setImportant(media, 'flex', '0 0 auto');
        setImportant(media, 'aspect-ratio', '4 / 5');
        setImportant(media, 'background', '#f2f3f5');
        setImportant(media, 'overflow', 'hidden');
        media?.querySelectorAll('img, video').forEach((asset) => {
          setImportant(asset, 'position', 'absolute');
          setImportant(asset, 'inset', '0');
          setImportant(asset, 'max-height', 'none');
          setImportant(asset, 'width', '100%');
          setImportant(asset, 'height', '100%');
          setImportant(asset, 'object-fit', 'cover');
          setImportant(asset, 'object-position', 'center');
          setImportant(asset, 'background', '#f2f3f5');
        });
        const caption = item.querySelector('.koppa-ugc__caption');
        setImportant(caption, 'display', compactProduct ? 'grid' : 'flex');
        caption?.querySelectorAll(':scope > *').forEach((part) => {
          setImportant(part, 'flex', '0 0 auto');
          setImportant(part, 'height', 'auto');
          setImportant(part, 'position', 'static');
          setImportant(part, 'background', 'transparent');
          setImportant(part, 'color', '#0b1b38');
        });
        setImportant(caption, 'width', '100%');
        setImportant(caption, 'flex', compactProduct ? '1 0 auto' : '0 0 auto');
        setImportant(caption, 'height', 'auto');
        if (compactProduct) setImportant(caption, 'aspect-ratio', 'auto');
        setImportant(caption, 'justify-content', 'flex-start');
        setImportant(caption, 'flex-direction', 'column');
        setImportant(caption, 'gap', compactProduct ? '12px 8px' : '8px');
        setImportant(caption, 'min-height', '0');
        setImportant(caption, 'padding', mobile ? '16px 14px' : '18px 16px 16px');
        const excerpt = item.querySelector('.community-review__excerpt');
        setImportant(excerpt, 'display', '-webkit-box');
        setImportant(excerpt, '-webkit-box-orient', 'vertical');
        setImportant(excerpt, '-webkit-line-clamp', '3');
        setImportant(excerpt, 'overflow', 'hidden');
        setImportant(excerpt, 'min-height', '0');
        setImportant(excerpt, 'margin', '0');
        setImportant(excerpt, 'order', '1');
        const meta = item.querySelector('.community-review__meta');
        setImportant(meta, 'display', 'flex');
        setImportant(meta, 'flex-direction', 'column');
        setImportant(meta, 'gap', '8px');
        setImportant(meta, 'width', '100%');
        setImportant(meta, 'order', '2');
        setImportant(meta, 'margin-top', '0');
        setImportant(meta, 'padding-top', '0');
        setImportant(meta, 'min-height', '0');
        const customer = item.querySelector('.community-review__customer');
        const productMeta = item.querySelector('.community-review__product');
        if (customer && caption && customer.parentElement !== caption) caption.prepend(customer);
        setImportant(customer, 'order', '0');
        setImportant(customer, 'margin', '0');
        setImportant(customer, 'display', 'block');
        setImportant(customer, 'width', '100%');
        setImportant(customer?.querySelector(':scope > span'), 'display', 'none');
        setImportant(productMeta, 'display', 'block');
        setImportant(productMeta, 'width', '100%');
        setImportant(productMeta, 'min-height', '0');
        setImportant(productMeta, 'margin', '0');
        setImportant(productMeta, 'padding-top', '10px');
        setImportant(productMeta, 'border-top', '1px solid #e1e5ea');
        setImportant(productMeta?.querySelector('img'), 'display', 'none');
        setImportant(productMeta?.querySelector(':scope > span'), 'display', 'block');
        setImportant(productMeta?.querySelector(':scope > span > span'), 'display', 'none');
        setImportant(productMeta?.querySelector('a'), 'display', 'block');
        let full = item.querySelector('details.community-review__full');
        if (compactProduct && !full && excerpt && caption) {
          full = document.createElement('details');
          full.className = 'community-review__full';
          const summary = document.createElement('summary');
          summary.textContent = root.querySelector('.community-review__full > summary')?.textContent || 'Read full review';
          const text = document.createElement('p');
          text.textContent = excerpt.textContent;
          full.append(summary, text);
          caption.append(full);
        }
        setImportant(full, 'display', 'block');
        setImportant(full, 'width', '100%');
        setImportant(full, 'order', '3');
        setImportant(full, 'margin', '0');
        setImportant(full, 'padding-top', '8px');
        setImportant(full, 'min-height', '0');
        if (compactProduct) {
          setImportant(caption, 'grid-template-columns', 'minmax(0,1fr) auto');
          setImportant(caption, 'grid-template-rows', 'auto 4.8em minmax(42px,auto) minmax(36px,auto)');
          setImportant(caption, 'font-size', '14px');
          setImportant(caption, 'line-height', '1.6');
          const stars = item.querySelector('.community-review__stars');
          [[customer,'1','1'],[stars,'2','1'],[excerpt,'1 / -1','2'],[meta,'1 / -1','3'],[full,'1 / -1','4']].forEach(([node,col,row]) => {
            setImportant(node, 'grid-column', col);
            setImportant(node, 'grid-row', row);
          });
          setImportant(stars, 'font-size', '12px');
          setImportant(stars, 'margin', '0');
          setImportant(excerpt, 'font-size', '14px');
          setImportant(excerpt, 'line-height', '1.6');
        }
      });
      setImportant(footer, 'display', 'flex');
      if (compactProduct) {
        [header, footer, track].forEach(node => setImportant(node, 'background', 'transparent'));
        setImportant(track, 'height', 'auto');
      }
    };
    const mountVersionA = (root) => {
      applyVersionA(root);
      root.querySelector('.koppa-ugc__track')?.addEventListener('scroll', () => requestAnimationFrame(() => applyVersionA(root)), {passive:true});
      root.addEventListener('toggle', () => requestAnimationFrame(() => applyVersionA(root)), true);
      new ResizeObserver(() => applyVersionA(root)).observe(root);
      new MutationObserver(() => applyVersionA(root)).observe(root, { childList: true, subtree: true });
    };
    const startVersionA = () => document.querySelectorAll('koppa-ugc[data-collection="shared"]').forEach(mountVersionA);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startVersionA);
    else startVersionA();
  }
  } catch(e) { console.error(e); }
})();

})();
